import { render, staticRenderFns } from "./AboutComp.vue?vue&type=template&id=12e25069&scoped=true&"
var script = {}
import style0 from "../assets/scss/about.scss?vue&type=style&index=0&id=12e25069&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e25069",
  null
  
)

export default component.exports